import * as React from "react";
const LegalActiveSVG = (props) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1_50229)">
      <path
        d="M18.6101 5.01872C18.8731 5.01899 19.1252 5.12357 19.3111 5.30949C19.497 5.49542 19.6016 5.7475 19.6019 6.01044V17.9906C19.6016 18.2535 19.497 18.5056 19.3111 18.6915C19.1252 18.8775 18.8731 18.982 18.6101 18.9823H6.63153C6.36863 18.9819 6.11662 18.8773 5.93073 18.6914C5.74483 18.5055 5.64022 18.2535 5.63981 17.9906V6.01044C5.64008 5.7475 5.74465 5.49542 5.93057 5.30949C6.1165 5.12357 6.36859 5.01899 6.63153 5.01872H18.6107M18.6107 4H6.63153C6.09833 4 5.58696 4.21182 5.20993 4.58885C4.8329 4.96588 4.62109 5.47723 4.62109 6.01044V17.9906C4.62136 18.5236 4.83329 19.0347 5.21029 19.4115C5.58729 19.7883 6.09851 20 6.63153 20H18.6107C19.1439 20 19.6552 19.7882 20.0322 19.4112C20.4093 19.0341 20.6211 18.5228 20.6211 17.9896V6.01044C20.6211 5.47723 20.4093 4.96588 20.0322 4.58885C19.6552 4.21182 19.1439 4 18.6107 4Z"
        fill="#888E9E"
      />
      <path
        d="M18.6101 5.01872C18.8731 5.01899 19.1252 5.12357 19.3111 5.30949C19.497 5.49542 19.6016 5.7475 19.6019 6.01044V17.9906C19.6016 18.2535 19.497 18.5056 19.3111 18.6915C19.1252 18.8775 18.8731 18.982 18.6101 18.9823H6.63153C6.36863 18.9819 6.11662 18.8773 5.93073 18.6914C5.74483 18.5055 5.64022 18.2535 5.63981 17.9906V6.01044C5.64008 5.7475 5.74465 5.49542 5.93057 5.30949C6.1165 5.12357 6.36859 5.01899 6.63153 5.01872H18.6107M18.6107 4H6.63153C6.09833 4 5.58696 4.21182 5.20993 4.58885C4.8329 4.96588 4.62109 5.47723 4.62109 6.01044V17.9906C4.62136 18.5236 4.83329 19.0347 5.21029 19.4115C5.58729 19.7883 6.09851 20 6.63153 20H18.6107C19.1439 20 19.6552 19.7882 20.0322 19.4112C20.4093 19.0341 20.6211 18.5228 20.6211 17.9896V6.01044C20.6211 5.47723 20.4093 4.96588 20.0322 4.58885C19.6552 4.21182 19.1439 4 18.6107 4Z"
        fill="url(#paint0_linear_1_50229)"
      />
      <path
        d="M16.7081 10.5978H8.65462C8.51953 10.5978 8.38997 10.5441 8.29444 10.4486C8.19892 10.3531 8.14526 10.2236 8.14526 10.0885C8.14526 9.95337 8.19892 9.8238 8.29444 9.72828C8.38997 9.63276 8.51953 9.5791 8.65462 9.5791H16.7081C16.8432 9.5791 16.9727 9.63276 17.0683 9.72828C17.1638 9.8238 17.2175 9.95337 17.2175 10.0885C17.2175 10.2236 17.1638 10.3531 17.0683 10.4486C16.9727 10.5441 16.8432 10.5978 16.7081 10.5978Z"
        fill="#888E9E"
      />
      <path
        d="M16.7081 10.5978H8.65462C8.51953 10.5978 8.38997 10.5441 8.29444 10.4486C8.19892 10.3531 8.14526 10.2236 8.14526 10.0885C8.14526 9.95337 8.19892 9.8238 8.29444 9.72828C8.38997 9.63276 8.51953 9.5791 8.65462 9.5791H16.7081C16.8432 9.5791 16.9727 9.63276 17.0683 9.72828C17.1638 9.8238 17.2175 9.95337 17.2175 10.0885C17.2175 10.2236 17.1638 10.3531 17.0683 10.4486C16.9727 10.5441 16.8432 10.5978 16.7081 10.5978Z"
        fill="url(#paint1_linear_1_50229)"
      />
      <path
        d="M16.7081 14.6252H8.65462C8.51953 14.6252 8.38997 14.5715 8.29444 14.476C8.19892 14.3804 8.14526 14.2509 8.14526 14.1158C8.14526 13.9807 8.19892 13.8511 8.29444 13.7556C8.38997 13.6601 8.51953 13.6064 8.65462 13.6064H16.7081C16.8432 13.6064 16.9727 13.6601 17.0683 13.7556C17.1638 13.8511 17.2175 13.9807 17.2175 14.1158C17.2175 14.2509 17.1638 14.3804 17.0683 14.476C16.9727 14.5715 16.8432 14.6252 16.7081 14.6252Z"
        fill="#888E9E"
      />
      <path
        d="M16.7081 14.6252H8.65462C8.51953 14.6252 8.38997 14.5715 8.29444 14.476C8.19892 14.3804 8.14526 14.2509 8.14526 14.1158C8.14526 13.9807 8.19892 13.8511 8.29444 13.7556C8.38997 13.6601 8.51953 13.6064 8.65462 13.6064H16.7081C16.8432 13.6064 16.9727 13.6601 17.0683 13.7556C17.1638 13.8511 17.2175 13.9807 17.2175 14.1158C17.2175 14.2509 17.1638 14.3804 17.0683 14.476C16.9727 14.5715 16.8432 14.6252 16.7081 14.6252Z"
        fill="url(#paint2_linear_1_50229)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1_50229"
        x1={12.6211}
        y1={4}
        x2={12.6211}
        y2={20}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#21B3FA" />
        <stop offset={1} stopColor="#FAB25C" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_50229"
        x1={12.6814}
        y1={9.5791}
        x2={12.6814}
        y2={10.5978}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#21B3FA" />
        <stop offset={1} stopColor="#FAB25C" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1_50229"
        x1={12.6814}
        y1={13.6064}
        x2={12.6814}
        y2={14.6252}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#21B3FA" />
        <stop offset={1} stopColor="#FAB25C" />
      </linearGradient>
      <clipPath id="clip0_1_50229">
        <rect
          width={16}
          height={16}
          fill="white"
          transform="translate(4.62012 4)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default LegalActiveSVG;
